// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#__layout,#__nuxt,body{height:100vh}.logo-container{position:fixed;left:0;top:0;opacity:1;padding:20px}body{background:none}.flat .container-fluid{box-shadow:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
